













import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import { PointList } from '@/models/point/list/point'
import { formatPoint } from '@/util/format'
import PointTable from '@spa/components/pages/mypage/point/list/layout/table/PointTable.vue'

@Component
/**
 * ポイントの初期化成功時に、実際にポイント一覧をレンダリングするためのレイアウトを決定するコンポーネント.
 */
export default class PointPresenter extends Vue {
  @Prop({ required: true })
  points: PointList

  // レイアウトの変更が必要な場合、ここで使用するレイアウトを交換する.
  // 何らかの基準によって動的に変更が必要な場合は、getプロパティ化しても良い.
  readonly layout = PointTable

  readonly formatPoint = formatPoint

  get totalPoint(): number {
    return this.points.total
  }
}
